import './forms_validation'
import './reservation_management_form'

import { initializeUtagEvents } from './forms.analytics'
import { initCRMValidation } from './forms_CRM_validation'
import { initSubmitFormRequest } from './forms_request'

function handleCountryChange() {
  const countryOptions = document.getElementById('country_id')
  const destinationLabel = document.querySelector(`label[for="destination_id"]`)

  countryOptions.addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex]
    const dataName = selectedOption.dataset.name
    destinationLabel.innerHTML = dataName
  })
}
let isSubmitRequest

document.addEventListener('DOMContentLoaded', () => {
  $(document)
    .on('focus', '.input-text input[type="text"], .input-text input[type="email"]', function (event) {
      $(this).closest('.input-text').addClass('focused')
    })
    .on('blur', '.input-text input[type="text"], .input-text input[type="email"]', function (event) {
      $(this).closest('.input-text').removeClass('focused')
    })

  $(document).on('keyup', '.password-row input.password', function () {
    const $el = $(this)
    if ($el.hasClass('parsley-success')) {
      $el.closest('.password-row').find('.validation-errors').addClass('hidden')
      $el.closest('.password-row').find('.validation-success').removeClass('hidden')
    } else {
      $el.closest('.password-row').find('.validation-errors').removeClass('hidden')
      $el.closest('.password-row').find('.validation-success').addClass('hidden')
    }
  })

  const ibeProHome = document.querySelector('.js-iberostarpro-home')

  if (!ibeProHome) {
    // Fetch handler in Contact Form
    const contactForm = document.querySelector('.js-contact-us')
    initializeUtagEvents()
    initSubmitFormRequest()

    if (contactForm) {
      const reasonSelect = contactForm.querySelector('#reason')
      const typeReasonSelect = contactForm.querySelector('#type_of_reason')
      const destinationHotelTitle = contactForm.querySelector('.js-destination-section-hotel')
      const destinationStayTitle = contactForm.querySelector('.js-destination-section-stay')
      const clickButton = contactForm.querySelector('.js-click-button')
      const submitButton = contactForm.querySelector('.js-submit-button')

      let isClaimReason = false
      const handleReasonChange = function (event) {
        const selectedReasonOption = reasonSelect.options[reasonSelect.selectedIndex]
        isClaimReason = selectedReasonOption.value === 'claim'
      }

      reasonSelect.addEventListener('change', handleReasonChange)

      typeReasonSelect.addEventListener('change', function () {
        const selectedOption = typeReasonSelect.options[typeReasonSelect.selectedIndex]
        const isStayClaimRequest = selectedOption.value === '16'
        const flashMessageValidated =
          contactForm.querySelector('.alert-success') || contactForm.querySelector('.alert-danger')

        handleCountryChange(contactForm)

        if (flashMessageValidated) {
          flashMessageValidated.classList.add('hidden')
          flashMessageValidated.classList.remove('alert-success', 'alert-danger')
        }

        destinationHotelTitle.classList.toggle('hidden', isStayClaimRequest)
        submitButton.classList.toggle('hidden', isStayClaimRequest)
        destinationStayTitle.classList.toggle('hidden', !isStayClaimRequest)
        clickButton.classList.toggle('hidden', !isStayClaimRequest)

        if (isClaimReason && isStayClaimRequest) {
          clickButton.classList.remove('hidden')
          submitButton.classList.add('hidden')
          initCRMValidation()
        }
      })
    }
  }
})
